import { FC } from 'react'

interface IFolderColorBallsProps {
	colorCode: string
}

const FolderColorBalls: FC<IFolderColorBallsProps> = ({ colorCode }) => {
	return (
		<>
			{Array.from({ length: 2 }).map((_, index) => (
				<div key={index} className='flex items-center gap-[2px]'>
					<span
						style={{ background: colorCode || '#B3B3B3' }}
						className='w-[6px] h-[6px] rounded-full'
					/>
					<span
						style={{ background: colorCode || '#B3B3B3' }}
						className='w-[6px] h-[6px] rounded-full'
					/>
				</div>
			))}
		</>
	)
}

export default FolderColorBalls
